/**
 * EVENT_COLORS — keep in sync with backend EventType.
 */
export const EVENT_COLORS = {
  birthday: "#FF8E72",
  birthday_fun: "#FFB199",
  party: "#FF2D92",
  anniversary: "#E55A8E",
  milestone: "#B36BFF",
  trip: "#00E5FF",
  vacation: "#37C7E5",
  relax: "#7CD9A8",
  my_home: "#FFB300",
  baby: "#F4A6CD",
  fundraiser: "#FFD60A",
  general: "#9EA1D4",
  pickleball: "#7CB342",
  workout: "#FF3B30",
};
